/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconMessageMicrophone = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      d="M13.5 7.789c0 2.626-2.421 4.713-4.767 5.088v1.6h2.197c.405 0 .733.342.733.762s-.328.761-.733.761H5.07c-.404 0-.732-.341-.732-.761s.328-.761.733-.761h2.197v-1.6C4.923 12.505 2.5 10.418 2.5 7.791V5.765c0-.42.328-.76.732-.76.405 0 .733.34.733.76v2.026c0 1.954 2.217 3.629 4.032 3.629 1.818 0 4.038-1.675 4.038-3.63l-.006-2.027c0-.42.326-.762.73-.763h.003c.403 0 .731.339.732.76l.006 2.029zm-3-5.289v5a2.5 2.5 0 1 1-5 0v-5a2.5 2.5 0 1 1 5 0z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

IconMessageMicrophone.displayName = 'IconMessageMicrophone';

IconMessageMicrophone.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconMessageMicrophone);
IconMessageMicrophone.displayName = 'IconMessageMicrophone';
